import { Observable } from 'rxjs';
import { CreateUserRulesTemplateRequest, EditUserRulesTemplateRequest } from '../domain/requests/user-rules-template';
import { UserRulesTemplate } from '../domain/models/user-rules-template';

export abstract class UserRulesTemplateRepository {
    abstract getUserRulesTemplatesByUserId(): Observable<UserRulesTemplate[]>;
    abstract getUserRulesTemplatesByUserIdIncludingDefault(): Observable<UserRulesTemplate[]>;
    abstract getUserRulesTemplateById(request: string): Observable<UserRulesTemplate>;
    abstract CreateUserRulesTemplate(request: CreateUserRulesTemplateRequest): Observable<string>;
    abstract EditUserRulesTemplate(request: EditUserRulesTemplateRequest): Observable<string>;
    abstract DeleteUserRulesTemplate(request: string): Observable<boolean>;
}
